import React, {useEffect} from 'react'
import {MarkdownView} from '../../common/MarkdownView'
import {highlightAll} from 'prismjs/components/prism-core'
import 'prismjs/components/prism-sql'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'

interface ISchemaDescriptionProps {
  id: string
}

const SchemaDescription: React.FC<ISchemaDescriptionProps> = () => {
  const description = useSelector<IReduxState, any | undefined>((state) => state.task?.schemaDescription?.description)

  useEffect(() => {
    highlightAll()
  }, [])

  return (
    <div className={'pl-x4 mt-n-x1'}>
      <MarkdownView content={description} />
    </div>
  )
}

export {SchemaDescription}
